

import axios from "axios";


const apiClient = axios.create({
//   baseURL: 'https://hdvms.site/backend/index.php/api',
// baseURL: 'https://vms.dktsoft.in/backend/index.php/api',
baseURL: 'https://securevisit.in/backend/index.php/api',
  timeout: 30000,
});

apiClient.interceptors.request.use((config) => {
  // List of endpoints to exclude from showing loader
  const excludeLoaderUrls = [
    'getGatepassUpdated',
    'getEmpGatepassUpdated',
    'refreshVisitorGatepass'
  ];

  const shouldShowLoader = !excludeLoaderUrls.some(url => config.url.includes(url));

  config.headers['Authorization'] = localStorage['token'] || 'na';
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded';

  if (shouldShowLoader) {
    $(".global-loader").show();
    // config.meta = { showLoader: true }; // custom flag for response interceptor
  }

  return config;
}, (error) => {
  $(".global-loader").hide();
  return Promise.reject(error);
});

apiClient.interceptors.response.use((response) => {
  $(".global-loader").hide();
    if (response.data && typeof response.data === 'string' && response.data.includes("Not Trusted")) {
    handleLogout();
  }
  
  
  return response;
}, (error) => {
  $(".global-loader").hide();
  if (error.code === 'ECONNABORTED') {
      alert("Request timed out. Please check your network or try again.");
    }
    
  return Promise.reject(error);
});

function handleLogout() {
  alert("Session expired or not trusted. You will be logged out.");
  localStorage.clear(); // or remove only token: localStorage.removeItem('token');
  window.location.href = "/login"; // redirect to your login route
}

export default apiClient;